import permissions from '../../data/permissions';

export default [
    {
        name: "DebitNoteCreate",
        path: "debit-note",
        component: () => import('./../../views/purchase/DebitNoteCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.debit_note.create }
    },
    {
        name: "DebitNoteList",
        path: "debit-notes",
        component: () => import('./../../views/purchase/DebitNoteListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.debit_note.index}
    },
    {
        name: "DebitNoteDisplay",
        path: "debit-note/:id",
        component: () => import('./../../views/purchase/DebitNoteDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.debit_note.read }
    },
    {
        name: "DebitNoteEdit",
        path: "debit-note/:id/edit",
        component: () => import('./../../views/purchase/DebitNoteEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.debit_note.update }
    },

]